import { basePath } from 'src/env';

export const RoutePaths = {
    index: `${basePath}/`,
};
